export default "__VITE_ASSET__BGzaMElU__"